import { Text } from '@chakra-ui/react';
import React from 'react';

import { ActionConfig } from './types';
import { VerificationActionKeyGQLType } from '../../../../../types/dashboard-core-gqlTypes.generated.d';
import { Icon } from '~/packages/common-frontend/components/icons';
import { getVerificationPayloadWithAssert } from '~/packages/common-frontend/utils';

// Exports
export const verification: Record<
  VerificationActionKeyGQLType,
  ActionConfig
> = {
  verificationReportApproved: {
    Component: function InsertDeliverableItemComponent({ event }) {
      const { actorName } = event;
      const payload = getVerificationPayloadWithAssert(event);
      const { creditFacilityName } = payload;
      return (
        <Text>
          <strong>{`${actorName} approved`}</strong>
          {` a verification report for `}
          <strong>{creditFacilityName}</strong>
        </Text>
      );
    },
    icon: <Icon icon="check" />,
  },
  verificationReportRejected: {
    Component: function InsertDeliverableItemComponent({ event }) {
      const { actorName } = event;
      const payload = getVerificationPayloadWithAssert(event);
      const { creditFacilityName } = payload;
      return (
        <Text>
          <strong>{`${actorName} rejected`}</strong>
          {` a verification report for `}
          <strong>{creditFacilityName}</strong>
        </Text>
      );
    },
    icon: <Icon icon="xmark-large" />,
  },
};
